/*
 * Updates a catalog, optionally uses vuex
 *
 * Usage: catalogService.update('highway', highway_updated)
 *          .then(=> ...)
 *
 * Auto collection management (updates the element from list)
 *  catalogService.update('highway', new, old, {source: highways})
 *
 * Vuex integration
 *  catalogService.update('highway', new, old, {useStore: true})
 */

import Vue from 'vue'
import store from './../../store'
import catalogTransformers from './../../transformers/catalog'
import errorHandler from '@/utils/errorHandler'

const success = function (payload) {
  store.dispatch('catalogs/update', payload)
}

const failure = function (error) {
  throw error
}

const updateSource = function (source, item, original) {
  if (!source) {
    logError(type)
    return
  }

  let index = source.indexOf(item)

  if (index !== -1) {
    source.splice(index, 1)
  } 
}

export default (type, catalog, oldCatalog, config = {}) => {
  let payload = catalog
  const transformer = catalogTransformers[type]
  let id = payload.id

  if (transformer && transformer.send) {
    payload = transformer.send(payload)
  }

  if (payload instanceof FormData) {
    config.headers = {
      'content-type': 'multipart/form-data',
    }
    id = payload.get('id')
  }

  let doMakeErrorMessage = true

  if (config.dontMakeErrorMessage) {
    doMakeErrorMessage = false
    config.dontMakeErrorMessage = null
  }

  let useStore = config.useStore
  config.useStore = null

  let source = config.source
  config.source = null

  let url = `/catalogs/${type}/${id}/`

  let request = Vue.$http.put(url, payload, config)

  request = doMakeErrorMessage ? errorHandler(request) : request

  return request.then(response => {
    let data = response.data

    if (transformer && transformer.fetch) {
      data = transformer.fetch(data)
    }

    if (useStore) {
      success({ type, data, old_data: oldCatalog })
    }

    if (source) {
      updateSource(source, catalog, oldCatalog)
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/services/catalog/update.js